import { dialogService } from '@thefarmersfront/kitchen';

import { jwtDecode } from 'jwt-decode';

import { authDBService } from '~/services';

import { PATH } from '~/constants';
import { type TypeLogisticsType, type TypeOwnerType } from '~/constants/common';

import { TypeUserClass } from '~/types/common.types';

export type TypeDecodedToken = {
  loginId: string;
  name: string;
  ownerCode: string;
  ownerName: string;
  ownerType: TypeOwnerType;
  logisticsTypes: TypeLogisticsType[];
  userClass: TypeUserClass;
};

const getDecodedJwtValue = async () => {
  try {
    const loginInfo = await authDBService.getLoginInfo();
    const token = loginInfo?.access_token;

    const decodedJwtValue = jwtDecode<TypeDecodedToken>(token ?? '');

    return decodedJwtValue;
  } catch (error) {
    dialogService.addDialog({
      title: '토큰 인증 실패',
      children: (
        <>
          토큰 인증에 실패했습니다.
          <br />
          {'확인'} 선택 시 로그인 화면으로 이동합니다.
        </>
      ),
      onConfirm: () => {
        if (window.globalNavigate) {
          window.globalNavigate(PATH.LOGOUT);
        } else {
          window.location.href = PATH.LOGOUT;
        }
      },
    });
  }
};

export default getDecodedJwtValue;
